import { BuyToneDto, BuyToneDtoImpl } from '../../../../core/dto/buytone/buytonedto';
import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState } from '../../../toolkit/uicomponent';
import { ToneDto } from '../../../../core/dto/tonedto';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { BuyToneCSSStyleImpl } from './buytonecss';
import { BuyToneAPIModelImpl, BuyToneAPIModel } from './buytoneapimodel';
import { BuyToneViewImpl } from './buytoneview';
import { ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { GetTonePriceDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedetailsdto';
import { GetPackDetails } from '../getpackdetails';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { PopUpWrapperComponent } from '../popupwrappercomponent';

export interface BuyToneComponentProps extends UIComponentProps
{
    toneOptionsType: ToneOptionsType;
    toneDto: ToneDto;
    getPopupWrapper():PopUpWrapperComponent|any;
    showPopupOption(id:string):void;
    closePopup(): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface BuyToneComponentState extends  UIComponentState
{
    isPrice: boolean;
    price:string;
    packName: string;
    msisdn: string;
    isNewUser:boolean;
    isPackUpgradeSelected:boolean;

}

export interface BuyToneComponentHandler extends UIComponentHandler
{
    onConfirmClick(): void;
    onPackSelected(isPackUpgradeSelected:boolean): void;
    onRequestOtpClick(): void;
}

export class BuyToneComponent extends UIComponentImpl<BuyToneComponentProps, BuyToneComponentState, BuyToneDto> 
implements BuyToneComponentHandler
{
    constructor(props: BuyToneComponentProps, state:BuyToneComponentState)
    {
        super(props);
        this.state={price:this.getContext().getUserContext().getIsLoggedIn() ? '' : 
        this.getContext().getResources().getString(Strings.gift_default_value),
         packName: '', isPrice: false, msisdn: "",isNewUser:false, isPackUpgradeSelected:false};
    }
   
    componentDidMount()
    {
        
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getView() as BuyToneViewImpl).showLoader();   
            (this.getAPIModel() as BuyToneAPIModel).getTonePrice(this.props.toneDto);
        }
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<BuyToneDto>
    {
        return new BuyToneViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new BuyToneCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new BuyToneAPIModelImpl(applicationContext, apiModelHandler);
    }

    onConfirmClick(): void 
    {
        
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            console.log("-----this.state.isPackUpgradeSelected: " + this.state.packName);

            if(this.state.isPackUpgradeSelected)
            {
                this.props.context.getUserContext().setMsisdnB(this.getContext().getUserContext().getMsisdn());
                (this.props.context.getUserContext().setSecToken(""));
                this.props.context.getUserContext().setPackName(this.state.packName);
                this.props.context.getUserContext().setIsnewUser(this.state.isNewUser);
                this.props.context.setUserContext(this.props.context.getUserContext());

                this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
                this.props.context.getResources().getString(Strings.upgradePack));
            }
            else if(this.state.isNewUser)
            {
                (this.props.context.getUserContext().setMsisdnB(this.getContext().getUserContext().getMsisdn()));
                this.props.context.setUserContext(this.props.context.getUserContext());
                this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now)+ "_" + this.props.context.getResources().getString(Strings.subscription));
            }
            else
            {
               
            (this.getView() as BuyToneViewImpl).showLoader();  
            let buyTone = new BuyToneDtoImpl();
            buyTone.setToneId(this.props.toneOptionsType === ToneOptionsType.TONE ? this.props.toneDto.getId()
            : this.props.toneDto.getContentId().split("|")[0]);
            buyTone.setToneName(this.props.toneDto.getToneName());
            buyTone.setUserName(this.props.context.getUserContext().getUsername());
            buyTone.setChannel(this.props.context.getUserContext().getChannelId());
            buyTone.setMsisdn(this.props.context.getUserContext().getMsisdn());
            buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
            buyTone.setPackName(this.state.packName);
            

            this.props.toneOptionsType === ToneOptionsType.TONE ? 
            (this.getAPIModel() as BuyToneAPIModel).buyTone(buyTone)
            : (this.getAPIModel() as BuyToneAPIModel).buyMusicChannelAPI(buyTone);
        }
    }
        else 
        {
             if((this.getView() as BuyToneViewImpl).validate())
              {
                (this.getView() as BuyToneViewImpl).showLoader();  
                (this.getAPIModel() as BuyToneAPIModel).getTonePriceNonLoggedInuser((this.getView() as BuyToneViewImpl).getData());
              } 
        }
    }

    onPackSelected(isPackUpgradeSelected: boolean): void 
    {
        console.log("-----this.state.isPackUpgradeSelected: " + isPackUpgradeSelected);
      this.setState({isPackUpgradeSelected: isPackUpgradeSelected});
    }


    onRequestOtpClick()
    {
          (this.getView() as BuyToneViewImpl).showLoader();  
          (this.getAPIModel() as BuyToneAPIModel).getOTP((this.getView() as BuyToneViewImpl).getOTPData());
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.GET_TONE_PRICE)
        {
            (this.getView() as BuyToneViewImpl).dismissLoader();  
            let packDetails = this.props.context.getConfigurationSettings().getPropertyBasedOnLanguage("VALIDITY");
            
            console.log("packdetails: " + packDetails);
      
        
            let PRICE_TEXT: string = new GetPackDetails(packDetails)
            .getPrice((data as GetTonePriceDetailsDto).getPackName(),
            (data as GetTonePriceDetailsDto).getPrice());
             
            
             console.log("-----tigerPRICE_TEXT: " + PRICE_TEXT +", packName: " + (data as GetTonePriceDetailsDto).getPackName());
             this.setState({price:PRICE_TEXT, msisdn: description, isPrice: true, packName: (data as GetTonePriceDetailsDto).getPackName()});
             this.setState({isNewUser:(data as GetTonePriceDetailsDto).getIsNewUser()});
             console.log("get tone price on buy now:",this.state.packName);
        }
        else if(feature === APIFeatures.BUY_TONE)
        {
            console.log("------buy");
            console.log("------"+this.state.packName);
            (this.getView() as BuyToneViewImpl).dismissLoader();  
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.setUserContext(this.props.context.getUserContext());
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   

        }
       else  if(feature === APIFeatures.GENERATE_OTP)
        {
            (this.getView() as BuyToneViewImpl).dismissLoader();  
            this.props.context.getUserContext().setMsisdnB(this.state.msisdn);
            (this.props.context.getUserContext().setSecToken(""));
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.getUserContext().setIsnewUser(this.state.isNewUser);
            this.props.context.setUserContext(this.props.context.getUserContext());

            if(this.state.isPackUpgradeSelected)
            { 
                //login route after confirm for non-logged in user

                this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
                this.props.context.getResources().getString(Strings.upgradePack) + "_" + 
                this.props.context.getResources().getString(Strings.otp_verification));
                console.log("upgrade pack redirection :Buy Now");

            }
            else
            {
                this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
                this.props.context.getResources().getString(Strings.otp_verification));
            }
        }
        else
        {
            (this.getView() as BuyToneViewImpl).dismissLoader();    
        }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as BuyToneViewImpl).dismissLoader();  
        if(feature === APIFeatures.BUY_TONE)
        {
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   

        }
        else
        {
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   

        }
    }  
        
            
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/buytone/buytonecomponent.tsx